import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";

export const subscribeWembiiSupportAgentAction = createAction(
  "[WembiiSupport Socket] Agent Subscribe",
  props<{
    userId: string;
    conversationId?: string;
    room?: string;
  }>()
);

export const subscribeWembiiSupportClientAction = createAction(
  "[WembiiSupport Socket] Client Subscribe",
  props<{
    userId: string;
    conversationId: string;
    room: string;
  }>()
);

export const sendWembiiSupportMessageAction = createAction(
  "[WembiiSupport Socket] Send Message",
  props<{
    conversationId: string;
    content: string;
    senderType: "user" | "agent";
    senderId: string;
    consultationLabel?: string;
  }>()
);

export const disconnectWembiiSupportClientAction = createAction(
  "[WembiiSupport Socket] Client Disconnect",
  props<{ conversationId: string }>()
);

const actions = joinActions({
  subscribeWembiiSupportAgentAction,
  subscribeWembiiSupportClientAction,
  sendWembiiSupportMessageAction,
  disconnectWembiiSupportClientAction,
});

export type WembiiSupportSocketAction = typeof actions;
